// extracted by mini-css-extract-plugin
export default {"grayContainer":"ContactDetails_grayContainer__cHUSv"};